export class AllVegnettStatisticsResponseGruppert {
    constructor(
        readonly antall: number,
        readonly vegkategori: string,
        readonly fylke: number
    ) {}
}
